import { IfspReviewResponse } from '../../pages/IFSPReview/IFSPReviewScreen';
import { ApiResponseHandler } from '../ApiResponseHandler';
import { REFERRAL_PROGRAM_KEY } from '../Constant';
import ThomApiClient from '../ThomApiClient';

export const getIfspReviewData = async (
  page: number,
  size: number,
  sortField: string,
  sortDirection: 'asc' | 'desc',
  search: string,
): Promise<IfspReviewResponse> => {
  const referralProgramId = localStorage.getItem(REFERRAL_PROGRAM_KEY);
  return ApiResponseHandler(
    await ThomApiClient.getInstance().get<IfspReviewResponse>(
      `/ifsp/review?page=${page}&size=${size}&sortField=${sortField}&sortDirection=${sortDirection}&search=${search}&referralProgramId=${
        referralProgramId ?? ''
      }`,
    ),
  );
};
